import { render, staticRenderFns } from "./liucheng-3.vue?vue&type=template&id=40e9d810&scoped=true"
import script from "./liucheng-3.vue?vue&type=script&lang=js"
export * from "./liucheng-3.vue?vue&type=script&lang=js"
import style0 from "./liucheng-3.vue?vue&type=style&index=0&id=40e9d810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9d810",
  null
  
)

export default component.exports